import React from 'react';
import { Button } from 'antd';
import logoPng from 'assets/images/logo-full.png';
import ProcessingTeamImpersonationBar, { useIsImpersonating } from 'components/Atoms/Bars/ProcessingTeamImpersonationBar/ProcessingTeamImpersonationBar';
import MobileBottomNav from '../MobileBottomNav/MobileBottomNav';
import { useNavigate } from 'react-router-dom';
import { BORROWER_ONBOARDING_URL } from '@common/config/environments';
import { useGetOAuthToken } from 'services/auth/mutations';

const HeaderHome = () => {
  const navigate = useNavigate();
  const { execute: getOAuthToken } = useGetOAuthToken();

  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
           (window.innerWidth <= 768);
  };

  const onCreateNewLoan = () => {
    getOAuthToken({})
      .then(({ data }) => {
        if (data?.getOAuthToken) {
          const oAuthToken = data.getOAuthToken;
          window.location.href = `${BORROWER_ONBOARDING_URL}/?oauth=${oAuthToken}&origin=borrower-dashboard`;
        } else {
          // Fallback: redirect without token if generation fails
          window.location.href = `${BORROWER_ONBOARDING_URL}/`;
        }
      })
      .catch(() => {
        window.location.href = `${BORROWER_ONBOARDING_URL}/`;
      });
  }

  const { showProcessingBar }  = useIsImpersonating();

  const componentClassName = showProcessingBar ? 'HeaderHome-space processing' : 'HeaderHome-space';
  return (
    <div className={componentClassName}>
      <div className="HeaderHome">
        {
          showProcessingBar &&
          <ProcessingTeamImpersonationBar />
        }
        <div className='content'>
          <div
            className="icon-container"
            onClick={() => { window.location.href = "https://www.constlending.com"; }}
          >
            <img src={logoPng} alt="logo" width={178} />
          </div>
          <Button className="button button-secondary" onClick={onCreateNewLoan}>New loan</Button>
        </div>
      </div>

      <MobileBottomNav />
    </div>
  );
};
export default HeaderHome;
